import type { BCCWJMemoryStatus } from '../types'

// Single source of truth for the memory-status labels; used by both
// WordTriage and BCCWJBrowser.
export const BCCWJ_MEMORY_STATUS_LABELS: Record<BCCWJMemoryStatus, string> = {
  1: '認識できない',
  2: '意味がときどきわかる',
  3: 'すぐ意味がわかる',
  4: '会話で使える',
}

export const BCCWJ_UNRATED_LABEL = '未評価'

export function statusLabel(status?: BCCWJMemoryStatus | null): string {
  // ?? guards against an out-of-range status written directly to the DB (the
  // table has no CHECK constraint) sneaking past the 1|2|3|4 type.
  return status == null ? BCCWJ_UNRATED_LABEL : BCCWJ_MEMORY_STATUS_LABELS[status] ?? BCCWJ_UNRATED_LABEL
}

// CSS class per level (colors live in BCCWJBrowser.css)
export const BCCWJ_STATUS_BADGE_CLASS: Record<BCCWJMemoryStatus, string> = {
  1: 'bccwj-status-1',
  2: 'bccwj-status-2',
  3: 'bccwj-status-3',
  4: 'bccwj-status-4',
}

// Same out-of-range guard as statusLabel: unrated/unknown -> the gray class.
export function statusBadgeClass(status?: BCCWJMemoryStatus | null): string {
  const unrated = 'bccwj-status-unrated'
  return status == null ? unrated : BCCWJ_STATUS_BADGE_CLASS[status] ?? unrated
}

// Shared by the browser's filter checkboxes and the inline per-row selector.
// value 'none' = unrated; values '1'-'4' match the API status filter.
export const BCCWJ_STATUS_FILTER_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'none', label: BCCWJ_UNRATED_LABEL },
  { value: '1', label: BCCWJ_MEMORY_STATUS_LABELS[1] },
  { value: '2', label: BCCWJ_MEMORY_STATUS_LABELS[2] },
  { value: '3', label: BCCWJ_MEMORY_STATUS_LABELS[3] },
  { value: '4', label: BCCWJ_MEMORY_STATUS_LABELS[4] },
]

// Per-card radio display (browser cards): compact numeric labels; the full
// labels live in the aria-labels and the grid legend. value 'none' = unrated,
// same convention as BCCWJ_STATUS_FILTER_OPTIONS and the API status filter.
export const BCCWJ_STATUS_RADIO_OPTIONS: Array<{ value: string; label: string; ariaLabel: string }> = [
  { value: 'none', label: '−', ariaLabel: BCCWJ_UNRATED_LABEL },
  { value: '1', label: '1', ariaLabel: BCCWJ_MEMORY_STATUS_LABELS[1] },
  { value: '2', label: '2', ariaLabel: BCCWJ_MEMORY_STATUS_LABELS[2] },
  { value: '3', label: '3', ariaLabel: BCCWJ_MEMORY_STATUS_LABELS[3] },
  { value: '4', label: '4', ariaLabel: BCCWJ_MEMORY_STATUS_LABELS[4] },
]
